import { use_slice_ui } from '@/hooks/store/use_slices';
import { WatcherSlugPageCollections } from '../_base/watchers/set_workspace_current/WatcherSlugPageCollections';
import { WatcherViewEntityCollection } from '../_base/watchers/viewers/WatcherViewEntityCollection';
import { C_PAGE_LAYOUT__collections_desktop } from './C_PAGE_LAYOUT__collections_desktop';
import { PageCollectionsViewsMobile } from './PageCollectionsViewsMobile';

export function C_PAGE__collections() {
  const { global_is_mobile } = use_slice_ui(['global_is_mobile']);

  return (
    <>
      <WatcherSlugPageCollections />
      <WatcherViewEntityCollection />

      {global_is_mobile ? <PageCollectionsViewsMobile /> : <C_PAGE_LAYOUT__collections_desktop />}
    </>
  );
}
